const faqs = [
  {
    question: "Does New Jersey have its own regional passport agency?",
    answer:
      "New Jersey does not have a state-level passport agency. The nearest regional passport agencies for most of New Jersey are the New York Passport Agency in Manhattan (closest for northern NJ) and the Philadelphia Passport Agency (closest for southern NJ). Both require appointments and proof of travel within 14 days.",
  },
  {
    question: "How fast can I get a passport in New Jersey?",
    answer:
      "With Fast Passport Center's courier service, New Jersey travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in New Jersey?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, municipal clerk, or library). Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major international airports near New Jersey include Newark Liberty (EWR), JFK, and LaGuardia (LGA). Atlantic City International (ACY) also offers some international service.",
  },
  {
    question: "Can I renew by mail from New Jersey?",
    answer:
      "Yes. Adult passport renewals (Form DS-82) can be submitted by mail from any New Jersey address if your previous passport was issued within the last 15 years when you were age 16 or older, and you can submit it with your application.",
  },
  {
    question: "Where is the best place to get a passport photo in New Jersey?",
    answer:
      "CVS, Walgreens, UPS Store, and FedEx Office locations are widely available across New Jersey and typically offer walk-in passport photo service. Many municipal clerks and post offices that serve as acceptance facilities also offer photos on-site.",
  },
];

export { faqs };

export default function NewJerseyFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            New Jersey Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Garden State.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}